import { create } from "zustand";

type UserAssignmentExportDialogStore = {
    isOpen: boolean;
    isExporting: boolean;
    openExportDialog: () => void;
    close: () => void;
    setLoading: (isLoading: boolean) => void;
};

export const useUserAssignmentExportDialogStore = create<UserAssignmentExportDialogStore>((set) => ({
    isOpen: false,
    isExporting: false,
    openExportDialog: () =>
        set(() => ({
            isOpen: true
        })),
    close: () => {
        set(() => ({ isOpen: false}));
    },
    setLoading: (isLoading: boolean) => set(() => ({ isExporting: isLoading })),
}));